import { PageStyles } from "../pageStyles";
import { SubsSchema } from "../sub";
import { z } from "zod";
export const EnabledProductSchema = z.object({
    product: z.enum([
        "primary",
        "secondary",
        "tertiary"
    ])
});
/**
 * Tells the parent we're ready to start receiving messages.
 */ export const OutgoingMessagePingSchema = z.object({
    event_name: z.literal("ping"),
    substitutions: SubsSchema,
    products: z.array(EnabledProductSchema).optional(),
    coordinates: z.record(z.string(), z.object({
        x: z.number(),
        y: z.number()
    })).optional(),
    version: z.string().optional(),
    fonts: z.array(z.object({
        family: z.string()
    })).optional(),
    page_styles: PageStyles
});
/**
 * Tells the parent to close the paywall
 */ const OutgoingMessageClose = z.object({
    event_name: z.literal("close")
});
/**
 * Tells the parent to open a url
 */ const OutgoingMessageOpenURL = z.object({
    event_name: z.literal("open_url"),
    url: z.string()
});
/**
 * Tells the parent to open a url externally
 */ const OutgoingMessageOpenExternalURL = z.object({
    event_name: z.literal("open_url_external"),
    url: z.string()
});
/**
 * Tells the parent to open a deep link
 */ const OutgoingMessageOpenDeepLink = z.object({
    event_name: z.literal("open_deep_link"),
    link: z.string()
});
/**
 * Tells the parent to restore a purchase
 */ const OutgoingMessageRestore = z.object({
    event_name: z.literal("restore")
});
/**
 * Tells the parent to purchase a product
 */ const OutgoingMessagePurchase = z.object({
    event_name: z.literal("purchase"),
    product: z.string(),
    product_identifier: z.string().optional()
});
/**
 * Tells the parent to send a custom message
 */ const OutgoingMessageCustom = z.object({
    event_name: z.literal("custom"),
    data: z.string()
});
/**
 * Tells the parent to send a custom message
 */ const OutgoingMessageCustomPlacement = z.object({
    event_name: z.literal("custom_placement"),
    name: z.string(),
    params: z.object({}).passthrough()
});
/**
 * Tells the parent we clicked a variable
 */ // This should really be sub_click, why did I do this!?
const OutgoingMessageVarClick = z.object({
    event_name: z.literal("var_click"),
    var_name: z.string()
});
const OutgoingMessagePageStyles = z.object({
    event_name: z.literal("page_styles"),
    page_styles: PageStyles
});
const OutgoingMessageHasSetDom = z.object({
    event_name: z.literal("has_set_dom"),
    data: z.object({}).passthrough()
});
const OutgoingInitiateWebCheckout = z.object({
    event_name: z.literal("initiate_web_checkout"),
    checkout_session_id: z.string(),
    // Parameters needed for transaction_start event
    product_identifier: z.string(),
    paywall_identifier: z.string().optional(),
    experiment_variant_id: z.string().optional(),
    presented_by_event_name: z.string().optional(),
    store: z.literal("STRIPE")
});
export const OutgoingMessageSchema = z.union([
    OutgoingMessagePingSchema,
    OutgoingMessageClose,
    OutgoingMessageOpenURL,
    OutgoingMessageOpenExternalURL,
    OutgoingMessageOpenDeepLink,
    OutgoingMessageRestore,
    OutgoingMessagePurchase,
    OutgoingMessageCustom,
    OutgoingMessageVarClick,
    OutgoingMessagePageStyles,
    OutgoingMessageHasSetDom,
    OutgoingMessageCustomPlacement,
    OutgoingInitiateWebCheckout
]);
